"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LESSON_ORDER_GAP = void 0;
var LESSON_ORDER_GAP = 10;
exports.LESSON_ORDER_GAP = LESSON_ORDER_GAP;